/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 **/
export const PAGE_RESOURCES = {
  DASHBOARD_DASHBOARD: 'dashboard.dashboard',
  USERS_SIGNIN: 'users.signin',
  USERS_AUTHERROR: 'users.autherror',
  DASHBOARD_LEARNING: 'dashboard.learning',
  DASHBOARD_DATA: 'dashboard.data',
  DASHBOARD_CONTENT_BUILDER: 'dashboard.content-builder',
} as const;